import React, { FC } from 'react'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import WrapperImage from '../wrapperImage'

//* styles
import { RichTextWrapper } from '../../../styles/global'
import { StyledAnnouncement } from './style'

type Props = {
  iconSrc: string
  iconAlt: string
  text: string
}

export const AnnouncementBanner: FC<Props> = ({ iconSrc, iconAlt, text }) => (
  <StyledAnnouncement data-cy="announcement">
    <div className="Announcement__Inner">
      {iconSrc && iconAlt && (
        <div className="Announcement__Inner-Icon">
          <WrapperImage src={iconSrc} alt={iconAlt} height={16} width={16} threshold={650} />
        </div>
      )}

      {text && (
        <div className="Announcement__Inner-Text">
          <RichTextWrapper $type="bodyXS">{renderRichText(text)}</RichTextWrapper>
        </div>
      )}
    </div>
  </StyledAnnouncement>
)
